import { createSlice, createAsyncThunk, current } from '@reduxjs/toolkit';
import lodash, { set } from 'lodash';
import ProviderManager from '../../../provider/providerManager';
import { showAppLoader, hideAppLoader } from '../../Shared/Loader/LoaderSlice';
import { TAB_ENUM } from '../../Page/SelfCarePage/Constant';
import { isMobile } from 'react-device-detect';
import moment from 'moment';

export const getInternetProducts = createAsyncThunk('zoneFaultBlock/getInternetProducts', async (data, thunkAPI) => {
    try {
        thunkAPI.dispatch(showAppLoader());
        const selfcarePage = thunkAPI.getState().selfcarePage;

        const providerData = await ProviderManager.getProviderData('getInternetProducts', {});
        let res = providerData?.Body;
        const productsInfo = res?.productsInfo;
        const selectedBanFromSelfCare = (selfcarePage?.isFetchData ? selfcarePage?.selectedSubscriber?.ban : '');


        if (providerData?.Body?.successResult?.isSuccess) {

            if (productsInfo.length > 1) {

                thunkAPI.dispatch(setProductsList(productsInfo));

                const defaultProductIndex = selectedBanFromSelfCare ?  productsInfo.findIndex(product => product.ban === selectedBanFromSelfCare) : -1;
                if (defaultProductIndex !== -1) {
                    thunkAPI.dispatch(setSelectedProduct(productsInfo[defaultProductIndex]));
                    await thunkAPI.dispatch(getZoneFaultStatus({ showAppLoader: true }));
                }
                else{
                  thunkAPI.dispatch(goToPage('productsPage'));
                }

            } else if (productsInfo.length === 1) {

                thunkAPI.dispatch(setSelectedProduct(productsInfo[0]));
                await thunkAPI.dispatch(getZoneFaultStatus({ showAppLoader: true }));

            } else {
                thunkAPI.dispatch(goToPage('noServicePage'));

            }
        } else {
            thunkAPI.dispatch(goToPage('errorPage'));

        }
    } catch (error) {
        thunkAPI.dispatch(goToPage('errorPage'));
        thunkAPI.dispatch(hideAppLoader());

    } finally {
        thunkAPI.dispatch(hideAppLoader());
    }
});

export const getZoneFaultStatus = createAsyncThunk('zoneFaultBlock/getZoneFaultStatus', async (data, thunkAPI) => {
    try {

        if (data?.showAppLoader) {
            thunkAPI.dispatch(showAppLoader());
        }

        const state = thunkAPI.getState().zoneFaultBlock;
        const ban = state.selectedProduct.ban;

        const params = {
            idNumber: state.selectedProduct.idNumber,
            ban: ban,
        };

        const cachedData = sessionStorage.getItem(`zoneFaultStatus_${ban}`);
        if (cachedData) {
            const { timestamp, response } = JSON.parse(cachedData);
            const cacheMinutes = state.cacheMinutes;
            const minutes = cacheMinutes * 60 * 1000;
            if (Date.now() - timestamp < minutes) {
                const updatedResponse = updateStatusTimeText(response);
                thunkAPI.dispatch(setZoneFaultStatus(updatedResponse));
                thunkAPI.dispatch(goToPage('statusPage'));
                return;
            }
        }

        const result = await ProviderManager.getProviderData('getZoneFaultStatus', params);
        if (result?.Header?.ReturnCode === 0 && result?.Body?.successResult?.isSuccess) {

            sessionStorage.setItem(`zoneFaultStatus_${ban}`, JSON.stringify({ timestamp: Date.now(), response: result?.Body }));

            thunkAPI.dispatch(setZoneFaultStatus(result?.Body));
            thunkAPI.dispatch(goToPage('statusPage'));

        } else {
            thunkAPI.dispatch(goToPage('errorPage'));
        }
    } catch (error) {
        thunkAPI.dispatch(goToPage('errorPage'));
    }
    finally {
        thunkAPI.dispatch(hideAppLoader());
    }
    return;
});

export const sendNotificationToUser = createAsyncThunk('zoneFaultBlock/sendNotificationToUser', async (data, thunkAPI) => {
    try {
        const state = thunkAPI.getState().zoneFaultBlock;
        const ban = state.selectedProduct.ban;

        const params = {
            ban: ban,
        };

        const result = await ProviderManager.getProviderData('zoneFaultSendNotificationToUser', params);

        if (result?.Body?.isSuccess) {
            thunkAPI.dispatch(reportDWH({status: 'Completed',messageText: 'Success',actionType: 'Sending Fault Msg Request'}));
        } else {
            thunkAPI.dispatch(reportDWH({status: 'Error',messageText: 'General Error',actionType: 'Sending Fault Msg Request'}));
        }

        return result.Body;
    } catch (error) {
    }
});

export const prepareBlockAsync = createAsyncThunk('zoneFaultBlock/prepareBlockAsync', async (data, thunkAPI) => {
    try {

        thunkAPI.dispatch(showAppLoader());

        const authentication = thunkAPI.getState().authentication;
        const magicLinkParameters = authentication?.loginData?.magicLinkParameters;

        if (magicLinkParameters) {
            const selectedProduct = {
                ban: magicLinkParameters?.ban,
                idNumber: magicLinkParameters?.idNumber,
            };
            thunkAPI.dispatch(setSelectedProduct(selectedProduct));
            thunkAPI.dispatch(setIsmagicLink(true));
            await thunkAPI.dispatch(getZoneFaultStatus({ showAppLoader: true }));

        } else {
            await thunkAPI.dispatch(getInternetProducts());
        }
    } catch (error) {
        thunkAPI.dispatch(hideAppLoader());
        thunkAPI.dispatch(goToPage('errorPage'));
    }
});

const updateStatusTimeText = (response) => {
    const endDate = response?.endDate;
    const currentDate = moment().format("DD/MM/YYYY");
    const currentTime = moment().format("HH:mm");
    let statusTimeText = "";
    if (endDate && moment(endDate, "DD/MM/YYYY").format("DD/MM/YYYY") === currentDate) {
        statusTimeText = `התעדכן בשעה ${currentTime}`;
    } else {
        //statusTimeText = `עודכן בשעה ${currentTime} בתאריך ${moment(endDate, "DD/MM/YYYY").format("DD.MM.YYYY")}`;
        statusTimeText = `עודכן בתאריך ${moment(currentDate, "DD/MM/YYYY").format("DD.MM.YY")} בשעה: ${currentTime}`;
    }
    return { ...response, statusTimeText };
};

const initialState = {
    page: '',
    selectedProduct: {},
    isMagicLink: false,
    productsList: {},
    zoneFaultStatus: {
        endDate: '',
        endTime: '',
        faultOrJobType: '',
        message: '',
        status: '',
        address: '',
        StatusTimeText: ''
    },
    isSendNotificationToUser: false,
    isSuccessSendNotificationToUser: false,
    cacheMinutes: "",
};

const zoneFaultBlockSlice = createSlice({
    name: 'zoneFaultBlock',
    initialState: initialState,
    reducers: {
        goToPage: (state, action) => {
            state.page = action.payload;
        },
        setLoginType: (state, action) => {
            state.loginType = action.payload;
        },
        setProductsList: (state, action) => {
            state.productsList = action.payload;
        },
        setSelectedProduct: (state, action) => {
            state.selectedProduct = action.payload;
        },
        setZoneFaultStatus: (state, action) => {
            state.zoneFaultStatus = action.payload;
        },
        setCacheMinutes: (state, action) => {
            state.cacheMinutes = action.payload;
        },
        setIsmagicLink: (state, action) => {
            state.isMagicLink = action.payload;
        },
        setIsSendNotificationToUser: (state , action) => {
            state.isSendNotificationToUser = action.payload;
        },
        reportDWH: (state, action) => { },
    },
    extraReducers: {
        [sendNotificationToUser.fulfilled]: (state, action) => {
            if (!action.payload) {
              return;
            }
            state.isSendNotificationToUser = true;
            state.isSuccessSendNotificationToUser = action.payload.isSuccess;
          },
    }
});

export const { goToPage, reportDWH, setProductsList, setSelectedProduct, setZoneFaultStatus, setCacheMinutes, setIsmagicLink, setIsSendNotificationToUser } = zoneFaultBlockSlice.actions;
export default zoneFaultBlockSlice.reducer;
